var _path;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgImgBook(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 11V1.5C14 0.6875 13.3125 0 12.5 0H2.5C1.09375 0 0 1.125 0 2.5V13.5C0 14.9062 1.09375 16 2.5 16H13.25C13.6562 16 14 15.6875 14 15.25C14 14.8438 13.6562 14.5 13.25 14.5H13V12.4375C13.5625 12.2188 14 11.6562 14 11ZM11.5 14.5H2.5C1.9375 14.5 1.5 14.0625 1.5 13.5C1.5 12.9688 1.9375 12.5 2.5 12.5H11.5V14.5ZM12.5 11H2.5C2.125 11 1.78125 11.0938 1.5 11.2188V2.5C1.5 1.96875 1.9375 1.5 2.5 1.5H12.5V11ZM4.75 5H10.25C10.6562 5 11 4.6875 11 4.25C11 3.84375 10.6562 3.5 10.25 3.5H4.75C4.3125 3.5 4 3.84375 4 4.25C4 4.6875 4.3125 5 4.75 5ZM4.75 7.5H10.25C10.6562 7.5 11 7.1875 11 6.75C11 6.34375 10.6562 6 10.25 6H4.75C4.3125 6 4 6.34375 4 6.75C4 7.1875 4.3125 7.5 4.75 7.5Z",
    fill: "#0073BF"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgBook);
export default __webpack_public_path__ + "static/media/img_book.f66a2800ae489a668cba45e9c7a32a0a.svg";
export { ForwardRef as ReactComponent };